import MicrosoftIcon from '@mui/icons-material/Microsoft'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { FormattedMessage } from 'react-intl'
import {
  MoovyButton,
  MoovyContainer,
  MoovyContainerContent,
  MoovyContainerHeader,
} from '../../components'
import useAuth from '../../hooks/useAuth'

const Login = () => {
  const { login, hasConfigurationError } = useAuth()
  return (
    <MoovyContainer>
      <MoovyContainerHeader>
        <FormattedMessage id="login.title" />
      </MoovyContainerHeader>
      <MoovyContainerContent>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '30vh',
          }}
        >
          {hasConfigurationError ? (
            <Typography fontWeight="bold" color="error">
              <FormattedMessage id="authentication.error.configuration" />
            </Typography>
          ) : (
            <MoovyButton onClick={login}>
              <Box
                sx={{
                  height: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <MicrosoftIcon style={{ marginRight: '0.5rem' }} />
                <FormattedMessage id="login.button.azure" />
              </Box>
            </MoovyButton>
          )}
        </Box>
      </MoovyContainerContent>
    </MoovyContainer>
  )
}

export default Login
